/** Public website links the editor points demo users to. */

export const BOOK_DEMO_URL = 'https://calendly.com/anonify-info/30min';

const PRICING_URLS: Record<string, string> = {
  de: 'https://anonify.nl/de/preise',
  nl: 'https://anonify.nl/prijzen',
};
const PRICING_URL_DEFAULT = 'https://anonify.nl/en/pricing';

/** `de-AT` -> `de`; empty or odd input -> ''. */
const baseLanguage = (language?: string | null) =>
  (language || '').toLowerCase().split(/[-_]/)[0];

/** Pricing page in the visitor's language; English for every other language. */
export const pricingUrl = (language?: string | null): string =>
  PRICING_URLS[baseLanguage(language)] ?? PRICING_URL_DEFAULT;

// Plan section of the pricing page (ids on the website pricing page).
const PRICING_PLANS_URLS: Record<string, string> = {
  de: 'https://anonify.nl/de/preise#pakete',
  nl: 'https://anonify.nl/prijzen#pakketten',
};
const PRICING_PLANS_URL_DEFAULT = 'https://anonify.nl/en/pricing#plans';

/** Plan section of the pricing page; same language fallback as `pricingUrl`. */
export const pricingPlansUrl = (language?: string | null): string =>
  PRICING_PLANS_URLS[baseLanguage(language)] ?? PRICING_PLANS_URL_DEFAULT;

const PRIVACY_URLS: Record<string, string> = {
  de: 'https://anonify.nl/de/privacy-policy',
  en: 'https://anonify.nl/en/privacy-policy',
};
const PRIVACY_URL_DEFAULT = 'https://anonify.nl/privacy-policy';

/** Website privacy statement: Dutch at the root, English for other languages. */
export const privacyPolicyUrl = (language?: string | null): string => {
  const lng = baseLanguage(language);
  if (lng === 'nl') return PRIVACY_URL_DEFAULT;
  return PRIVACY_URLS[lng] ?? PRIVACY_URLS.en;
};
